import type { MonsterTokenStyle } from '../api';

const classicBacks = {
  commonItems: '/CommonItems/Back.jpg',
  uniqueItems: '/UniqueItems/Back.jpg',
  exhibits: '/UniqueItems/ExhibitItemBack.jpg',
  spells: '/Spells/Back.jpg',
  skills: '/Skills/Back.jpg',
  allies: '/Allies/Back.jpg',
  madnesses: '/MadnessBack.jpg',
  injuries: '/InjuryBack.jpg',
  cultEncounters: '/CultEncountersBack.jpg',
  corruptions: '/GreenCorruptionBack.jpg',
  monsters: '/Monster.jpg',
  gates: '/Gate.png',
} as const;

export type CardBackDeck = keyof typeof classicBacks;

const digitalBackNames: Record<CardBackDeck, string> = {
  commonItems: 'CommonItems', uniqueItems: 'UniqueItems', exhibits: 'Exhibits',
  spells: 'Spells', skills: 'Skills', allies: 'Allies', madnesses: 'Madnesses',
  injuries: 'Injuries', cultEncounters: 'CultEncounters', corruptions: 'GreenCorruption',
  monsters: 'Monsters', gates: 'Gates',
};

export function getCardBackPath(deck: CardBackDeck, style: MonsterTokenStyle | string, corruptionColor?: string): string {
  if (style !== 'Digital') {
    return deck === 'corruptions' && corruptionColor === 'Red' ? '/RedCorruptionBack.jpg' : classicBacks[deck];
  }
  const name = deck === 'corruptions' && corruptionColor === 'Red' ? 'RedCorruption' : digitalBackNames[deck];
  return `/CardBacks/Digital/small/${name}.jpg`;
}
